<template>
  <div v-if="user">
    <label for="user_name">Name</label>
    <input type="text" class="form-control" id="user_name" v-model="user.email">

    <button v-on:click="updateUser" type="button" class="btn btn-success">Update User</button>
  </div>

  <div v-else>
    There's actually nothing here.
  </div>
</template>

<script>

import { UserService } from '@/common/services/user.service';

export default {
  name: 'UserEdit',
  components: {

  },
  props: [
    'id',
  ],
  data() {
    return {
      user: null,
      errors: [],
    };
  },
  created() {
    this.getUser(this.id);
  },
  methods: {
    getUser(params) {
      UserService.get(params).then((response) => {
        this.user = response.data;
      });
    },
    updateUser() {
      UserService.update(this.id, this.user)
        .then(() => {
          this.$router.push({ name: 'UserShow', params: { id: this.id } });
        }).catch((err) => {
          this.errors = err.response.data.error;
        });
    }
  },
};

</script>

<style lang="scss" scoped>

</style>
